import { Float, Int } from '@adornis/baseql/baseqlTypes';
import { Entity, Field } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration';

@Entity()
export class GoalAgg extends MongoEntity {
  static _class = 'GoalAgg';
  static _collectionName = 'goalagg';
  static get allFields() {
    return selectionSet(() => GoalAgg, 1);
  }

  @Field(type => String) public _id!: string;
  @Field(type => String) public userName!: string;
  @Field(type => String) public pseudoRealname!: string;
  @Field(type => String) public userId!: string;
  @Field(type => Float) public score!: number;
  @Field(type => Int) public goalId!: string;
  @Field(type => String) public goalTitle!: string;
  @Field(type => String) public goalText!: string;
  @Field(type => String) public goalLevel!: string;
  @Field(type => [Int]) public taskIds!: number[];
  @Field(type => String) public courseGroup!: 'Laptop' | 'Solarzellen';
  // @Field(type => String) public courseCheck!: 'Laptop' | 'Solarzellen';
  @Field(type => String) public courseId!: string;
  @Field(type => String) public courseName!: string;
}
